export enum InvestmentType {
  vehicle = "vehicle",
  gold = "gold",
  diamonds = "diamonds",
  token = "token",
  whisky = "whisky",
  hotel = "hotel",
  parcel = "parcel",
  flat = "flat",
  dorm = "dorm",
  franchise = "franchise",
  artWork = "artWork",
}



// WEBPACK FOOTER //
// ./src/Models/EnumTypes/InvestmentEnumTypes.ts